import React from "react";
import {graphql} from "react-apollo";
import {flowRight as compose} from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS, Map} from "immutable";
import Form from "./CreateStockTransferForm";
import {cancelEditStockTransfer, successEditStockTransfer} from "../../../actions/StockTransferApiActions";
import {GET_STOCK_TRANSFER} from "../../../queries/stockTransfers";
import {getAllWarehouses} from "../../../lib/Warehouses";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";

const FIELDS = ["originWarehouseId", "destinationWarehouseId", "transportType", "carrierReference", "purchaseOrder", "orderDate", "expectedArrivalDate"];

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "originWarehouseId");
  errors = validatePresence(errors, values, "destinationWarehouseId");
  errors = validatePresence(errors, values, "transportType");
  return errors.toJS();
}

// Changes a transfer until it is dispatched: its warehouses, transport,
// references and dates. Dispatch checks the serials and stock against the
// origin as it is then.
class EditStockTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const data = FIELDS.reduce((acc, field) => ({...acc, [field]: values.get(field) || ""}), {transferId: this.props.transferId});

    return this.props.updateStockTransfer(data)
      .then((response) => {
        const errors = response.data.updateStockTransfer.errors;
        if (errors.length <= 0) {
          this.props.successEditStockTransfer();
        } else {
          this.setState({errors: createValidationErrors(errors, errors.map((error) => error.message).join("\n"))});
        }
      })
      .catch((err) => this.setState({errors: createErrors(err)}));
  }

  render() {
    const {loading, error, stockTransfer} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    return (
      <Form
        initialValues={fromJS(FIELDS.reduce((acc, field) => ({...acc, [field]: stockTransfer[field] || ""}), {}))}
        warehouses={getAllWarehouses()}
        errors={this.state.errors}
        validate={validateForm}
        submitLabel="Save"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={() => this.props.cancelEditStockTransfer()}
        />
    )
  }
}

const UPDATE_STOCK_TRANSFER = gql`
  mutation updateStockTransfer($data: UpdateStockTransferInput!) {
    updateStockTransfer(input: $data) {
      errors { key message }
    }
  }
`;

const withData = compose(
  graphql(GET_STOCK_TRANSFER, {options: (props) => ({fetchPolicy: "network-only", variables: {id: props.transferId}})}),
  graphql(UPDATE_STOCK_TRANSFER, {props: ({mutate}) => ({updateStockTransfer: (data) => mutate({variables: {data}})})}),
);

export default connect(null, {cancelEditStockTransfer, successEditStockTransfer})(withData(EditStockTransferFormContainer));
